import $ from 'jquery';
import _ from 'underscore';
import BaseTrackingView from '../../core/baseTrackingView';
import { getStorage } from '../../../home24/helpers/storage-factory';
import { getCurrentDataLayer } from '../../../home24-shared/tracking/common/helper';

export default BaseTrackingView.extend({

    selectors: {
        parent: '#pdp-app-root'
    },

    cookieCallbacks: {
        GtmOnArticleClicked: 'afterClick'
    },

    initialize: function () {
        this.bindEvents();
    },

    bindEvents: function () {
        // new format for PDP
        $(this.selectors.parent).on('click', '[data-gtm-bind-click]', _.bind(this.onClick, this));
    },

    onClick: function (event) {
        var $currentTarget = $(event.currentTarget);
        var dataAttributes = $($currentTarget).data();
        var storage = getStorage();
        var trackingData = {
            sku: dataAttributes.sku,
            position: dataAttributes.position,
            recommendationId: dataAttributes.recommendationId,
            source: this.getEventSource($currentTarget)
        };

        storage.set('GtmOnArticleClicked', trackingData);
    },

    getEventSource: function ($element) {
        var source = $element.data('gtmEventSource') || $element.closest('[data-gtm-event-source]').data('gtmEventSource');

        // add category name if available
        var categoryName = getCurrentDataLayer().pageProdGroup;

        if (categoryName) {
            // ie. 'Catalog - Möbel'
            source = source + ' - ' + categoryName;
        }

        return source;
    },

    // Callback for BaseTracking:executeCookieCallbacks executed when user enters PDP after clicking on article
    afterClick: function (storedTrackingData) {

        // this should be true: storedTrackingData.sku === trackingData.sku);
        var trackingData = this.model.get('trackingData');

        if (typeof window.dataLayer === 'object' && trackingData) {

            var productData = {
                name: trackingData.name,
                id: trackingData.sku,
                price: trackingData.price,
                brand: trackingData.brand,
                category: trackingData.category,
                variant: trackingData.variant,
                dimension64: trackingData.deliveryTime
            };

            if (storedTrackingData.position) {
                productData.position = storedTrackingData.position;
            }

            if (storedTrackingData.recommendationId) {
                productData.recommendationID = storedTrackingData.recommendationId;
            }

            window.dataLayer.push({
                event: 'productClick',
                ecommerce: {
                    click: {
                        actionField: {
                            list: storedTrackingData.source
                        },
                        products: [productData]
                    }
                }
            });
        }
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/pdp-new/ProductClick.js
 **/